import { yupResolver } from '@hookform/resolvers/yup';
import { Box, Button, Stack, Typography } from '@mui/material';
import { PromptDialogOnSide } from 'common/components/PromptDialogOnSide/PromptDialogOnSide';
import { styles } from 'common/components/PromptDialogOnSide/PromptDialogOnSide.styles';
import { FormDatePicker } from 'common/form/components/FormDatePicker/FormDatePicker';
import { DialogComponentProps } from 'common/hooks/useDialog';
import { FormProvider, useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import * as yup from 'yup';

interface FormValues {
  referenceDate?: Date | null;
}

export interface EditCashFlowAdjustmentReferenceDateDialogProps extends DialogComponentProps<Date | undefined | null> {
  referenceDate?: Date | null;
}

export const EditCashFlowAdjustmentReferenceDateDialog: React.FC<EditCashFlowAdjustmentReferenceDateDialogProps> = ({
  isOpen,
  onReject,
  onResolve,
  referenceDate,
}) => {
  const { t } = useTranslation();

  const schema: yup.SchemaOf<FormValues> = yup.object({
    referenceDate: yup.date().typeError(t('form.validator.invalidDate')).required(t('form.validator.fieldIsRequired')),
  });

  const formMethods = useForm<FormValues>({
    defaultValues: {
      referenceDate,
    } as FormValues,
    mode: 'onSubmit',
    reValidateMode: 'onChange',
    resolver: yupResolver(schema),
  });

  const handleSubmit = formMethods.handleSubmit(async (data) => {
    onResolve(data.referenceDate);
  });

  return (
    <PromptDialogOnSide
      onClose={() => onReject()}
      open={isOpen}
      title={t('fintelligenceReport.editCashFlowAdjustmentReferenceDateDialog.title')}
    >
      <FormProvider {...formMethods}>
        <Box component="form" noValidate onSubmit={handleSubmit}>
          <Box>
            <FormDatePicker name="referenceDate" />
          </Box>

          <Stack mt={3} spacing={1}>
            <Button color="primary" sx={styles.button} type="submit">
              <Typography color="white" variant="bodyL">
                {t('fintelligenceReport.editCashFlowAdjustmentReferenceDateDialog.save')}
              </Typography>
            </Button>
            <Button color="tertiaryButton" onClick={() => onReject()} sx={styles.button}>
              <Typography color="blue.dark" variant="bodyL">
                {t('common:cancel')}
              </Typography>
            </Button>
          </Stack>
        </Box>
      </FormProvider>
    </PromptDialogOnSide>
  );
};
